// Amplify user attributes are strings; the string "false" is truthy in JS.
export function hasVerifiedEmail(attributes) {
  return attributes?.email_verified === "true" || attributes?.email_verified === true;
}
